import { schema } from 'normalizr'

export const passengerSchema = new schema.Entity('passengers')
export default passengerSchema

export const passengersSchema = new schema.Array(passengerSchema)
